import { S21CsaComponent } from "./S21CsaComponent";

export function S21CsaScreen() {
  return (
    <>
      <S21CsaComponent />
    </>
  );
}
